import React from "react";
import CenteredLoadingIcon from "./CenteredLoadingIcon";
import { SubCard } from "./Layout";


function FullPriceDisplay(props) {

    const properType = (props.quantityType === "interview") ? "Interviews" : "Survey"
    const descriptorType = (props.quantityType === "interview") ? "Interviews" : "Responses"
    const priceDescription = (props.quantityType === "interview") ? "Price per interview" : "Price per response"


    return (
        <div className="full-price-card" >
            {props.price && props.quantity && props.totalPrice && props.quantityType ?
                <>
                    <div className="full-price-row">
                        <div className="full-price-row-title">
                            {properType}
                        </div>
                        <div className="full-price-details">
                            <PriceMultiplierColumn highlight={"$" + props.price} description={priceDescription} />
                            <div className="full-price-multiplier-container">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.00151 9.44293L11.7728 13.2143C11.8986 13.3357 12.067 13.4029 12.2418 13.4014C12.4166 13.3999 12.5838 13.3297 12.7074 13.2061C12.831 13.0825 12.9011 12.9153 12.9026 12.7405C12.9041 12.5657 12.8369 12.3973 12.7155 12.2716L8.94418 8.50026L12.7155 4.72893C12.8369 4.60319 12.9041 4.43479 12.9026 4.25999C12.9011 4.0852 12.831 3.91799 12.7074 3.79438C12.5838 3.67078 12.4166 3.60067 12.2418 3.59915C12.067 3.59763 11.8986 3.66482 11.7728 3.78626L8.00151 7.5576L4.23018 3.78626C4.10388 3.66783 3.93645 3.60317 3.76333 3.60598C3.59021 3.6088 3.42497 3.67885 3.30258 3.80132C3.18019 3.9238 3.11026 4.08909 3.10757 4.26221C3.10488 4.43533 3.16965 4.60271 3.28818 4.72893L7.05884 8.50026L3.28751 12.2716C3.22384 12.3331 3.17305 12.4067 3.13811 12.488C3.10317 12.5693 3.08478 12.6568 3.08401 12.7453C3.08324 12.8338 3.10011 12.9216 3.13363 13.0036C3.16715 13.0855 3.21665 13.1599 3.27925 13.2225C3.34184 13.2851 3.41628 13.3346 3.49821 13.3681C3.58014 13.4017 3.66792 13.4185 3.75644 13.4178C3.84496 13.417 3.93244 13.3986 4.01378 13.3637C4.09512 13.3287 4.16868 13.2779 4.23018 13.2143L8.00151 9.44293Z" fill="#FEFEFE" />
                                </svg>
                            </div>
                            <PriceMultiplierColumn highlight={props.quantity} description={descriptorType} />
                        </div>
                        <div className="full-price-row-total">
                            ${props.totalPrice}
                        </div>
                    </div>
                    <div className="full-price-total-row">
                        <div className="full-price-row-title">
                            Total:
                        </div>
                        <div className="full-price-row-total-column">
                            <div className="full-price-row-total">
                                ${props.totalPrice}
                            </div>
                            <div className="full-price-row-tax">
                                + applicable taxes
                            </div>
                        </div>
                    </div>
                </>
                :
                <CenteredLoadingIcon />
            }
        </div>
    )

}

function PriceMultiplierColumn(props) {
    return (
        <div className="full-price-multiplier-column">
            <div className="full-price-multiplier-highlight">
                {props.highlight}
            </div>
            <div className="full-price-multiplier-description">
                {props.description}
            </div>
        </div>
    )
}

export default FullPriceDisplay;